import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_65zgi875pr: FaireBrandEntity = {
  token: "b_65zgi875pr",
  type: "brand",
  name: "Laurel Burch Studios",
  avatarUrl:
    "https://cdn.faire.com/fastly/3b0b02c0bad5b1415f74f5b508d0309a0a2e9529e828a4848722e4d0dc889502.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c91deb86152e2621b97323a5dcfa6cda1db07092173438c5f767d7e72a340042.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3b0b02c0bad5b1415f74f5b508d0309a0a2e9529e828a4848722e4d0dc889502.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c91deb86152e2621b97323a5dcfa6cda1db07092173438c5f767d7e72a340042.png",
  location: "Berkeley, CA, USA",
  minimumOrderDollars: 208,
  rating: 4.6,
  reviewCount: 17,
  isTopShop: true,
  isInsider: true,
  description:
    "Laurel Burch Studios was launched by Laurel’s daughter Aarin Burch in 2012 to share the beautiful art and spirit of her mother’s joyful designs while growing Laurel Burch Jewelry and the brand in exciting new directions. Laurel Burch became a creative phenomenon in the 1960s when she began making original jewelry and selling it on the streets of San Francisco when she was only 19. Over the next forty years, she became an internationally known artist and designer with an instantly recognizable palette and style. Her fabulous jewelry and kaleidoscope of felines, flowers, mythical horses, and all manner of humankind are timeless, joyful, and uplifting designs – perfect for today. \n\nWe are an independent woman-owned jewelry company and retailer of a wide range of exuberant Laurel Burch-licensed apparel, accessories, crafts, and home goods inspired by Laurel’s bright, bold designs and carrying the integrity and quality expected of the brand. We are excited to offer new and classic jewelry collections created by Aarin and based on Laurel's uniquely original earrings, pendants, and necklaces. \n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:17.053Z",
    importedBy: "entity-db-cli",
  },
};
